/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Placeholder_TitleInputs */

const en_link_editor_placeholder_title = /** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button Title (e.g. My Website)`)
};

const es_link_editor_placeholder_title = /** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título del Botón (ej. Mi Sitio Web)`)
};

const fr_link_editor_placeholder_title = /** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre du bouton (ex. Mon site web)`)
};

const de_link_editor_placeholder_title = /** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaltflächentitel (z. B. Meine Website)`)
};

/** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */
const ja_link_editor_placeholder_title = en_link_editor_placeholder_title;

/** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */
const zh_link_editor_placeholder_title = en_link_editor_placeholder_title;

/** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */
const ar_link_editor_placeholder_title = en_link_editor_placeholder_title;

/** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */
const id_link_editor_placeholder_title = en_link_editor_placeholder_title;

/** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */
const it_link_editor_placeholder_title = en_link_editor_placeholder_title;

/** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */
const ru_link_editor_placeholder_title = en_link_editor_placeholder_title;

/** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */
const pt_link_editor_placeholder_title = en_link_editor_placeholder_title;

/** @type {(inputs: Link_Editor_Placeholder_TitleInputs) => LocalizedString} */
const ko_link_editor_placeholder_title = en_link_editor_placeholder_title;

/**
* | output |
* | --- |
* | "Button Title (e.g. My Website)" |
*
* @param {Link_Editor_Placeholder_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_placeholder_title = /** @type {((inputs?: Link_Editor_Placeholder_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Placeholder_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_placeholder_title(inputs)
	if (locale === "es") return es_link_editor_placeholder_title(inputs)
	if (locale === "fr") return fr_link_editor_placeholder_title(inputs)
	if (locale === "de") return de_link_editor_placeholder_title(inputs)
	if (locale === "ja") return ja_link_editor_placeholder_title(inputs)
	if (locale === "zh") return zh_link_editor_placeholder_title(inputs)
	if (locale === "ar") return ar_link_editor_placeholder_title(inputs)
	if (locale === "id") return id_link_editor_placeholder_title(inputs)
	if (locale === "it") return it_link_editor_placeholder_title(inputs)
	if (locale === "ru") return ru_link_editor_placeholder_title(inputs)
	if (locale === "pt") return pt_link_editor_placeholder_title(inputs)
	return ko_link_editor_placeholder_title(inputs)
});